import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-generalsetting',
  templateUrl: './generalsetting.component.html',
  styleUrls: ['./generalsetting.component.scss']
})
export class GeneralsettingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
